define('modules/editor/views/property_boxes/page_conversion',['require','exports','module','./base','../../models/editorstate','env','modules/lp_info/models/page','underscore','ldsh!../../templates/property_boxes/page_conversion'],function(require, exports, module){
  "use strict";
  var BasePropertyBox = require("./base"),
      EditorState = require("../../models/editorstate"),
      config = require("env"),
      Page = require("modules/lp_info/models/page"),
      _ = require("underscore");

  module.exports = BasePropertyBox.extend({
    template: require("ldsh!../../templates/property_boxes/page_conversion"),
    i18n: {
      "customizedPixel": "editor.page.defaultCustomizedPixel"
    },
    initialize: function() {
      _.extend(this.events, {
        "change .js-skip": "togglePixelUrl",
        "change .js-conditional-exec": "togglePixelUrl"
      });
      module.exports.__super__.initialize.apply(this,arguments);
      /*this.variantModel = EditorState.getVariant();
      this.page = new Page({ id: this.variantModel.get("pages_id") });
      this.listenTo(this.page, "change", this.setPixelUrl);
      this.page.fetch();*/
    },
    helpers: function() {
      var variantModel = EditorState.getVariant();
      return {
        pixelUrl: [config.apiHost, "track", variantModel.id + ".gif"].join("/"),
        isMultistep: variantModel.content.length > 2,
        steps: variantModel.content,
        isAMP: EditorState.getAMPState(),
        customizedPixel: this.$(".js-customizedPixel").val()
      };
    },
    /*setPixelUrl: function() {
      var fullUrl = this.page.get("full_url"),
          slashPos = fullUrl.lastIndexOf("/"),
          domain = fullUrl.substr(0, slashPos);
      var url = [config.apiHost, "track", this.variantModel.id + ".gif"].join("/");
      this.$("textarea").val(url);
    },*/
    togglePixelUrl: function() {
      var skip = this.model.get("skip"),
          conditional = this.model.get("conditionalExec");
      this.$(".js-pixel").toggle(skip);
      this.$(".js-exec-config").toggle(skip && conditional);
    },
    enableActiveIntegrations: function() {
      var integrations = EditorState.getActiveIntegrations();
      _.each(integrations, _.bind(function(value, key){
        this.$("option[value=" + key +  "]").prop("disabled", !value);
      }, this));
    },
    onBeforeRender: function(){
      if(!this.model.get("customizedPixel")){
        this.model.set("customizedPixel", this.i18n.message, {silent:true});
      }
    },
    onRender: function(){
      this.$el.i18n();
      this.togglePixelUrl();
      this.enableActiveIntegrations();
    }
  });
});

